/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { shape, string, bool } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { GRAPHQL_ENV } from '../../../gql';
import findContent from '../../../gql/queries/findContent';

import SubscriptionPDPInformation from './SubscriptionPDPInformation';

const SubscriptionPDP = ({ brand, copy, isPdpRedesignEnabled }) => {
    const findContentOptions = {
        brand: brand.domain,
        contentType: 'brand_configuration',
    };
    const GET_SUBSCRIPTION_INFORMATION = findContent(findContentOptions);
    return (
        <Query query={GET_SUBSCRIPTION_INFORMATION}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '82px' }} />;
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data?.findContent?.content?.entries) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'No product returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                let subscriptionInformation = <></>;

                const subscriptionData = {
                    terms: data.findContent?.content?.entries?.[0]?.other.subscription_terms || null,
                };

                if (subscriptionData.terms) {
                    subscriptionInformation = <SubscriptionPDPInformation copy={copy} data={subscriptionData} isPdpRedesignEnabled={isPdpRedesignEnabled} />;
                }
                return subscriptionInformation;
            }}
        </Query>
    );
};

SubscriptionPDP.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    copy: string.isRequired,
    isPdpRedesignEnabled: bool,
};
SubscriptionPDP.defaultProps = {

    isPdpRedesignEnabled: false,
};

export default SubscriptionPDP;
